import SignOutButton from "@/components/ui/sign-out-button";
import RedirectToAvatarButton from "@/components/ui/redirect-to-avatar-button";
import RedirectToHeygenButton from "@/components/ui/redirect-to-heygen-button";
import { LanguageSwitcher } from "@/components/ui/language-switcher";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";

export function MenuNav() {
  return (
    <div className="flex gap-3 items-center self-end smScreen:self-start">
      {/* Desktop Menu - visible on mdScreen and up */}
      <div className="hidden mdScreen:flex gap-3 items-center">
        <LanguageSwitcher />
        <RedirectToAvatarButton />
        <RedirectToHeygenButton />
        <SignOutButton />
      </div>

      {/* Mobile Menu - visible below mdScreen */}
      <div className="mdScreen:hidden">
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="outline" size="icon" className="h-9 w-9">
              <Menu className="h-4 w-4" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="right">
            <div className="flex flex-col gap-4 mt-8">
              <RedirectToAvatarButton />
              <RedirectToHeygenButton />
              <SignOutButton />
              <LanguageSwitcher />
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </div>
  );
}